import { FC } from 'react'
import styled from 'styled-components'
import { TJobCategory } from '../type/jobCategoryStoreType'
import EmptyArea from './EmptyArea'
import { CategoryItem, CategoryItemAll } from './categoryItem'

interface IFContainerCategoryItemProps {
  categories?: TJobCategory[]
  parentCategory?: TJobCategory
  className?: string
}

const ContainerCategoryItem: FC<IFContainerCategoryItemProps> = ({
  categories,
  parentCategory,
  className,
}) => {
  if (!categories?.length) {
    return <EmptyArea className={className} />
  }

  return (
    <StyledWrapper className={className}>
      {parentCategory && <CategoryItemAll parentCategory={parentCategory} />}
      {categories?.map((category) => (
        <CategoryItem key={category.id} category={category} />
      ))}
    </StyledWrapper>
  )
}

export default ContainerCategoryItem

const StyledWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: flex-start;
  align-content: flex-start;
  padding: 16px 20px;
`
